import React, { useState, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Teleprompter, { TeleprompterHandle } from './components/Teleprompter';
import Navigation from './components/Navigation';
import ScriptsPage from './pages/ScriptsPage';
import ControllerPage from './pages/ControllerPage';
import SyncPage from './pages/SyncPage';
import AccountPage from './pages/AccountPage';
import SettingsPage from './pages/SettingsPage';
import DemoSyncModePage from './pages/DemoSyncModePage';
export function App() {
  const [isScrolling, setIsScrolling] = useState(false);
  const [currentScript, setCurrentScript] = useState('This is a sample script for the teleprompter. You can load your own scripts using the Scripts option in the navigation bar. The text will scroll automatically when you press the Start button. You can adjust the speed and font size using the Controller option.');
  const [scrollSpeed, setScrollSpeed] = useState(2);
  const [fontSize, setFontSize] = useState(24);
  const [highlightColor, setHighlightColor] = useState('rgba(2, 25, 128, 0.2)');
  const teleprompterRef = useRef<TeleprompterHandle>(null);
  const toggleScrolling = () => {
    setIsScrolling(!isScrolling);
  };
  return <Router data-id="element-0">
      <div className="flex flex-col h-screen w-full bg-black text-[#51a7fa]" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Teleprompter ref={teleprompterRef} script={currentScript} isScrolling={isScrolling} scrollSpeed={scrollSpeed} fontSize={fontSize} toggleScrolling={toggleScrolling} highlightColor={highlightColor} data-id="element-4" />} data-id="element-3" />
          <Route path="/scripts" element={<ScriptsPage setCurrentScript={setCurrentScript} data-id="element-6" />} data-id="element-5" />
          <Route path="/controller" element={<ControllerPage isScrolling={isScrolling} toggleScrolling={toggleScrolling} scrollSpeed={scrollSpeed} setScrollSpeed={setScrollSpeed} fontSize={fontSize} setFontSize={setFontSize} data-id="element-8" />} data-id="element-7" />
          <Route path="/sync" element={<SyncPage data-id="element-10" />} data-id="element-9" />
          <Route path="/account" element={<AccountPage data-id="element-12" />} data-id="element-11" />
          <Route path="/settings" element={<SettingsPage fontSize={fontSize} setFontSize={setFontSize} highlightColor={highlightColor} setHighlightColor={setHighlightColor} data-id="element-14" />} data-id="element-13" />
          <Route path="/demo-sync/*" element={<DemoSyncModePage data-id="element-16" />} data-id="element-15" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-18" />} data-id="element-17" />
        </Routes>
        <Navigation isScrolling={isScrolling} toggleScrolling={toggleScrolling} data-id="element-19" />
      </div>
    </Router>;
}